export default __webpack_public_path__ + "static/media/jestLogo.8c542742.png";